module.exports = __webpack_public_path__ + "media/application/images/svgs/percent-021114b26817b87e363b9a328fb38e33.svg";